interface ReceiptPdfViewerProps {
  src: string;
  title?: string;
}

export function ReceiptPdfViewer({ src, title = 'Receipt PDF' }: ReceiptPdfViewerProps) {
  return (
    <div className="relative h-full w-full overflow-hidden bg-gray-900">
      <iframe
        src={src}
        title={title}
        className="h-full w-full border-0 bg-white"
      />
      <div className="absolute bottom-3 right-3 bg-black/40 px-3 py-1.5 rounded text-xs text-white/70 pointer-events-none">
        PDF preview
      </div>
    </div>
  );
}
